import { BaseClass } from "../master/mastermodel";

export class GetTestInformationDetailsRequest extends BaseClass {
  public ServiceCode: number;
  public TestCode: number;
  public ServiceName: string;
  public DepartmentName: string;
}

export class GetMasterObservationsRequest extends BaseClass {
  public SearchText: string;
}

export class TestInformationData {
  public TestCode: number;
  public ServiceCode: number;
  public Name: string;
  public ShortName: string;
  public DepartmentName: string;
  public PatientAgeProfile: string;
  public TestAvailability: string;
  public ServiceMapping: string;
  public TestType: string;
}

export class SpecimenData {
  public IsSpecimenAvailable: boolean;
  public SpecimenSource: string;
  public Quantity: number;
  public UOM: string;
  public Organism: string;
  public HasTestMethod: boolean;
  public TestMethod: string;
}

export class ObservationRange {
  public TestName: string;
  public GroupName: string;
  public MinVal: string;
  public MaxVal: string;
}

export class ObservationData {
  public OrderSeq: number;
  public Name: string;
  public ExaminationType: string;
  public UOM: string;
  public ObservationGroup: string;
  public Range?: ObservationRange;
}

export class TestInformationCompositeResponse {
  public TestInfo: TestInformationData;
  public Specimen: SpecimenData;
  public Observations: ObservationData[];
  public Notes: string;
}

export class SaveNotesInfoRequest extends BaseClass {
  public TestCode: number;
  public ServiceCode: number;
  public NotesText: string;
}

export class SaveObservationsInfoRequest extends BaseClass {
  public TestCode: number;
  public ServiceCode: number;
  public ObservationCode: number;
  public OrderSeq: number;
  public Name: string;
  public ExaminationType: string;
  public UOM: string;
  public ObservationGroup: string;
  public ReferenceRanges: string;
}

export class SaveSpecimenInfoRequest extends BaseClass {
  public TestCode: number;
  public ServiceCode: number;
  public IsSpecimenAvailable: boolean;
  public SpecimenSource: string;
  public Quantity: number;
  public UOM: string;
  public Organism: string;
  public HasTestMethod: boolean;
  public TestMethod: string;
}

export class SaveTestInformationRequest extends BaseClass {
  public TestCode: number;
  public ServiceCode: number;
  public Name: string;
  public ShortName: string;
  public DepartmentName: string;
  public PatientAgeProfile: string;
  public TestAvailability: string;
  public ServiceMapping: string;
  public TestType: string;
}
